import { useState, useEffect } from "react";
import MDBox from "ui/MDBox";
import MDTypography from "ui/MDTypography";
import MDInput from "ui/MDInput";
import MDAlert from "ui/MDAlert";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import karkunService from "services/karkun-service";
import { Card, FormControl, FormHelperText, Grid, MenuItem, Select } from "@mui/material";
import { useDispatch } from "react-redux";
import { addClient } from "../../redux/actions/clientActions";
import centerService from "services/center-service";
import { IconButton, SaveButton } from "../common/buttons";
import { ArrowDropDown } from "@mui/icons-material";
const AddKarkun = () => {
  const dispatch = useDispatch();
  const [centers, setCenters] = useState([]);
  const [suggestedKarkunId, setSuggestedKarkunId] = useState("");
  const [allKarkuns, setAllKarkuns] = useState([]);

  const [karkun, setKarkun] = useState({
    name: "",
    fathername: "",
    phone: "",
    email: "",
    marfat: "",
    ehad: "",
    address: "",
    center: "",
    karkunid: "",
    city: "Lahore",
    country: "Pakistan",
  });
  const cityOptions = ["Lahore", "Karachi", "Islamabad"];
  const countryOptions = ["Pakistan", "UnitedKingdom"];
  const [errors, setErrors] = useState({
    nameError: false,
    fathernameError: false,
    phoneError: false,
    emailError: false,
    marfatError: false,
    ehadError: false,
    addressError: false,
    cityError: false,
    countryError: false,
    centerError: false,

  });

  const [notification, setNotification] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (notification) {
      const timer = setTimeout(() => {
        setNotification(false);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [notification]);

  const changeHandler = (e) => {
    const { name, value } = e.target;

    if (name === "city") {
      setKarkun({
        ...karkun,
        city: value,
        country: value === "Lahore" ? "Pakistan" : karkun.country, // Lahore ho to Pakistan ho
      });
    } else {
      setKarkun({
        ...karkun,
        [name]: value,
      });
    }
  };


  useEffect(() => {
    const fetchSuggested = async () => {
      if (!karkun.center) return;

      const res = await karkunService.getSuggestedIdByCenter(karkun.center);
      if (res.success) {
        setSuggestedKarkunId(res.suggestedKarkunId);
        setKarkun(prev => ({ ...prev, karkunid: res.suggestedKarkunId }));
      }
    };

    fetchSuggested();
  }, [karkun.center]);






  useEffect(() => {
    const fetchcenters = async () => {
      const response = await centerService.getAll();
      if (response.success === true && response.centers) {
        console.log('centers', response.centers);
        setCenters(response.centers);
      }
    };
    fetchcenters();

  }, []);

  const submitHandler = async (e) => {
    e.preventDefault();

    // Reset errors
    setErrors({
      nameError: false,
      fathernameError: false,
      phoneError: false,
      emailError: false,
      marfatError: false,
      ehadError: false,
      addressError: false,
      cityError: false,
      countryError: false,
      centerError: false,

    });

    const mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    // Validate fields
    if (karkun.name.trim().length === 0) {
      setErrors({ ...errors, nameError: true });
      return;
    }

    if (karkun.fathername.trim().length === 0) {
      setErrors({ ...errors, fathernameError: true });
      return;
    }

    if (karkun.phone.trim().length === 0) {
      setErrors({ ...errors, phoneError: true });
      return;
    }



    if (karkun.marfat.trim().length === 0) {
      setErrors({ ...errors, marfatError: true });
      return;
    }

    if (!karkun.ehad || String(karkun.ehad).trim().length === 0) {
      setErrors({ ...errors, ehadError: true });
      return;
    }


    if (karkun.address.trim().length === 0) {
      setErrors({ ...errors, addressError: true });
      return;
    }

    if (karkun.city.trim().length === 0) {
      setErrors({ ...errors, cityError: true });
      return;
    }

    if (karkun.country.trim().length === 0) {
      setErrors({ ...errors, countryError: true });
      return;
    }

    if (karkun.center.trim().length === 0) {
      setErrors({ ...errors, centerError: true });
      return;
    }

    if (karkun.email.trim().length === 0 || !karkun.email.trim().match(mailFormat)) {
      setErrors((prev) => ({ ...prev, emailError: true }));
      return;
    }

    const karkunData = {
      name: karkun.name,
      fathername: karkun.fathername,
      phone: karkun.phone,
      email: karkun.email,
      center: karkun.center,
      marfat: karkun.marfat,
      karkunid: karkun.karkunid || suggestedKarkunId, // ✅ MUST
      ehad: karkun.ehad,
      address: karkun.address,
      city: karkun.city || "Lahore",
      country: karkun.city === "Lahore" ? "Pakistan" : karkun.country,

    };

    console.log("Sending Karkun data:", karkunData);

    setLoading(true);

    const response = await karkunService.create(karkunData);
    console.log('response', response);
    setLoading(false);
    if (response.success) {
      dispatch(addClient(karkunData));
      setNotification({
        type: 'success',
        message: response.message,
      });
      // Reset form after successful submission
      setKarkun({
        name: "",
        fathername: "",
        phone: "",
        email: "",
        center: "",
        marfat: "",
        ehad: "",
        address: "",
        city: "",
        country: "",


      });
    } else {
      setNotification({
        type: 'error',
        message: response.errors[0],
      });
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  Add Karkun
                </MDTypography>
                <SaveButton loading={loading} onClick={submitHandler} />
              </MDBox>
              <MDBox
                component="form"
                role="form"
                onSubmit={submitHandler}
                display="flex"
                flexDirection="column"
                py={0}
                px={3}
              >
                {notification && (
                  <MDAlert color={notification.type} mt="20px">
                    <MDTypography variant="body2" color="white">
                      {notification.message}
                    </MDTypography>
                  </MDAlert>
                )}
                <MDBox display="flex" flexDirection="row" mt={5} mb={3}>
                  <MDBox display="flex" flexDirection="column" alignItems="flex-start" width="100%" mr={2}>
                    <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                      Name
                    </MDTypography>
                    <MDBox mb={2} width="100%">
                      <MDInput
                        type="text"
                        fullWidth
                        name="name"
                        value={karkun.name}
                        onChange={changeHandler}
                        error={errors.nameError}
                      />
                      {errors.nameError && (
                        <MDTypography variant="caption" color="error" fontWeight="light">
                          Please provide name
                        </MDTypography>
                      )}
                    </MDBox>
                  </MDBox>

                  <MDBox display="flex" flexDirection="column" alignItems="flex-start" width="100%" mr={2}>
                    <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                      Father Name
                    </MDTypography>
                    <MDBox mb={2} width="100%">
                      <MDInput
                        type="text"
                        fullWidth
                        name="fathername"
                        value={karkun.fathername}
                        onChange={changeHandler}
                        error={errors.fathernameError}
                      />
                      {errors.fathernameError && (
                        <MDTypography variant="caption" color="error" fontWeight="light">
                          Please provide Father Name
                        </MDTypography>
                      )}
                    </MDBox>
                  </MDBox>
                  <MDBox display="flex" flexDirection="column" alignItems="flex-start" width="100%" mr={2}>
                    <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                      Contact
                    </MDTypography>
                    <MDBox mb={2} width="100%">
                      <MDInput
                        type="number"
                        fullWidth
                        name="phone"
                        value={karkun.phone}
                        onChange={changeHandler}
                        error={errors.phoneError}
                      />
                      {errors.phoneError && (
                        <MDTypography variant="caption" color="error" fontWeight="light">
                          Please provide Contact Number
                        </MDTypography>
                      )}
                    </MDBox>
                  </MDBox>
                  <MDBox display="flex" flexDirection="column" alignItems="flex-start" width="100%" mr={2}>
                    <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                      Email
                    </MDTypography>
                    <MDBox mb={2} width="100%">
                      <MDInput
                        type="email"
                        fullWidth
                        name="email"
                        value={karkun.email}
                        onChange={changeHandler}
                        error={errors.emailError}
                      />
                      {errors.emailError && (
                        <MDTypography variant="caption" color="error" fontWeight="light">
                          Please provide email
                        </MDTypography>
                      )}
                    </MDBox>
                  </MDBox>
                </MDBox>
                <MDBox display="flex" flexDirection="row" mb={3}>
                  <MDBox display="flex" flexDirection="column" alignItems="flex-start" width="100%" mr={2}>
                    <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                      Address
                    </MDTypography>
                    <MDBox mb={2} width="100%">
                      <MDInput
                        type="text"
                        fullWidth
                        name="address"
                        value={karkun?.address}
                        onChange={changeHandler}
                        error={errors.addressError}
                      />
                      {errors.addressError && (
                        <MDTypography variant="caption" color="error" fontWeight="light">
                          Please provide Address
                        </MDTypography>
                      )}
                    </MDBox>
                  </MDBox>
                  <MDBox display="flex" flexDirection="column" alignItems="flex-start" width="100%" mr={2}>
                    <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                      City
                    </MDTypography>
                    <MDBox mb={2} width="100%">
                      <Select
                        fullWidth
                        name="city"
                        value={karkun?.city || "Lahore"}
                        onChange={changeHandler}
                        error={errors.cityError}
                        sx={{ height: '45px' }}
                        IconComponent={() => (
                          <IconButton>
                            <ArrowDropDown />
                          </IconButton>
                        )}
                      >
                        {cityOptions.map((city) => (
                          <MenuItem key={city} value={city}>{city}</MenuItem>
                        ))}
                      </Select>

                      {errors.cityError && (
                        <MDTypography variant="caption" color="error" fontWeight="light">
                          Please provide a city
                        </MDTypography>
                      )}
                    </MDBox>
                  </MDBox>

                  <MDBox display="flex" flexDirection="column" alignItems="flex-start" width="100%" mr={2}>
                    <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                      Country
                    </MDTypography>
                    <MDBox mb={2} width="100%">
                      <Select
                        fullWidth
                        name="country"
                        value={karkun?.country || "Pakistan"} // Default to Pakistan
                        onChange={changeHandler}
                        displayEmpty
                        error={errors.countryError}
                        sx={{ height: '45px' }}
                        IconComponent={() => (
                          <IconButton>
                            <ArrowDropDown />
                          </IconButton>
                        )}
                      >

                        {countryOptions.map((country) => (
                          <MenuItem key={country} value={country}>{country}</MenuItem>
                        ))}
                      </Select>
                      {errors.countryError && (
                        <MDTypography variant="caption" color="error" fontWeight="light">
                          Please provide a country
                        </MDTypography>
                      )}
                    </MDBox>
                  </MDBox>
                  <MDBox display="flex" flexDirection="column" alignItems="flex-start" width="100%" mr={2}>
                    <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                      Arsa Ehad
                    </MDTypography>
                    <MDBox mb={2} width="100%">
                      <Select
                        fullWidth
                        name="ehad"
                        value={karkun?.ehad || ""}
                        onChange={changeHandler}
                        error={errors.ehadError}
                        sx={{ height: '45px' }}
                        IconComponent={() => (
                          <IconButton>
                            <ArrowDropDown />
                          </IconButton>
                        )}
                      >
                        {Array.from({ length: 50 }, (_, i) => {
                          const year = new Date().getFullYear() - i;
                          return (
                            <MenuItem key={year} value={year}>
                              {year}
                            </MenuItem>
                          );
                        })}
                      </Select>
                      {errors.ehadError && (
                        <FormHelperText error>Please provide Arsa Ehad</FormHelperText>
                      )}
                    </MDBox>
                  </MDBox>
                </MDBox>

                <MDBox display="flex" flexDirection="row" mb={3}>

                  <MDBox display="flex" flexDirection="column" alignItems="flex-start" width="100%" mr={2}>
                    <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                      Marfat
                    </MDTypography>
                    <MDBox mb={2} width="100%">
                      <MDInput
                        type="text"
                        fullWidth
                        name="marfat"
                        value={karkun?.marfat}
                        onChange={changeHandler}
                        error={errors.marfatError}
                      />
                      {errors.marfatError && (
                        <MDTypography variant="caption" color="error" fontWeight="light">
                          Please provide marfat name
                        </MDTypography>
                      )}
                    </MDBox>
                  </MDBox>


                  <MDBox display="flex" flexDirection="column" alignItems="flex-start" width="100%" mr={2}>
                    <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                      Center
                    </MDTypography>
                    <MDBox mb={1} width="100%">
                      <FormControl fullWidth error={errors.centerError}>
                        <Select
                          labelId="role-label"
                          sx={{ height: '45px' }}
                          name="center"
                          value={karkun.center || "default"}
                          onChange={changeHandler}
                          IconComponent={() => (
                            <IconButton>
                              <ArrowDropDown />
                            </IconButton>
                          )}>
                          <MenuItem disabled value="default">Select Center</MenuItem>
                          {centers.map((center) => (
                            <MenuItem key={center.centerId} value={center.id}>
                              {center.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      {errors.centerError && (
                        <MDTypography variant="caption" color="error" fontWeight="light">
                          The center must be selected
                        </MDTypography>
                      )}
                    </MDBox>
                  </MDBox>
                  <MDBox display="flex" flexDirection="column" alignItems="flex-start" width="100%">
                    <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                      Karkun ID
                    </MDTypography>
                    <MDInput
                      type="text"
                      fullWidth
                      name="karkunid"
                      value={karkun.karkunid || suggestedKarkunId}
                      onChange={changeHandler}
                    />
                  </MDBox>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

export default AddKarkun;
